module.exports = __webpack_public_path__ + "static/img-tax-screen-343827f6739b5a9dc293c4f7e41563bf.png";